<app-layout>
  <app-page-header
    [title]="'Eventos para venda'"
    [titleIcon]="'pi pi-shopping-cart'"
    [subtitle]="'Eventos em que você é vendedor. Abra a página do evento para ver os ingressos disponíveis para venda.'"
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Eventos para venda', icon: 'pi pi-shopping-cart' },
    ]">
    <app-button styleType="outlined" (btnClick)="goToSellerOrders()">
      <i class="pi pi-wallet me-2"></i>
      Minhas vendas
    </app-button>
  </app-page-header>
  <div class="seller-events-page container-fluid p-4">
    <app-seller-assigned-events-list />
  </div>
</app-layout>
